import styled from "styled-components";
import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { MediumText, NotificationText, SubTitle } from "../../../../components/typography";
import { FixedBodyDiv, TitleSpan } from "../team/view-team";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { useState } from "react";
import { RadioButton } from "../../../../components/ui/radio-button";

import { useNavigate } from "react-router-dom";
import { ObjectsEnum } from "../../../../assets/utils/enums/basket";
import { getStructureItem } from "../../../../assets/utils/pluralize-elements";

export default function StructureSettingsTab() {
    const [value, setValue] = useState("empty");
    const navigate = useNavigate();
    return (
        <FixedBodyDiv
            className={`w-60 ${SETTINGS_BODY_DIV} gap-3`}
            $isPadding={true}
        >
            <TitleSpan className="pb-0">
                <SubTitle>Структура</SubTitle>
                <NotificationText>Керування папками, шаблонами та їх структурою.</NotificationText>
            </TitleSpan>
            <StructureSection>
                <MediumText>Обрати шаблон CRM-системи</MediumText>
                <RadioButton
                    id="empty"
                    name="crm-template"
                    label="Порожня CRM"
                    checked={value === "empty"}
                    onChange={() => setValue("empty")}
                >
                    <NotificationText>Почніть з чистого простору та налаштуйте CRM повністю під свій бізнес. Ви самі додаєте поля, етапи, ролі та автоматизації у зручному для вас форматі.</NotificationText>
                    <NotificationText className="accent-text">Усі налаштування можна змінити в будь-який момент.</NotificationText>
                </RadioButton>
                <RadioButton
                    id="autoservice"
                    name="crm-template"
                    label="Автосервіс"
                    checked={value === "autoservice"}
                    onChange={() => setValue("autoservice")}
                >
                    <NotificationText>Готова CRM з типовими послугами, етапами ремонту та ролями персоналу.</NotificationText>
                    <NotificationText className="accent-text">Усі налаштування можна змінити в будь-який момент.</NotificationText>
                </RadioButton>
                <RadioButton
                    id="beautysalon"
                    name="crm-template"
                    label="Салон краси"
                    checked={value === "beautysalon"}
                    onChange={() => setValue("beautysalon")}
                >
                    <NotificationText>CRM з готовими послугами, записами клієнтів та ролями майстрів.</NotificationText>
                    <NotificationText className="accent-text">Усі налаштування можна змінити в будь-який момент.</NotificationText>
                </RadioButton>
            </StructureSection>

            <StructureSection>
                <TitleSpan>
                    <MediumText>Редагувати папки</MediumText>
                    <NotificationText>Налаштування полів вплине на структуру всіх записів у таблицях та папці. Ви можете організувати поля в групи і згорнути ті, які ви рідко використовуєте в структурі запису. Для отримання додаткової інформації щодо конструктора полів (папок), перейдіть до нашого <b className="fw-normal accent-text">Посібника Користувача.</b></NotificationText>
                    <NotificationText className="accent-text">Дізнатися більше</NotificationText>
                </TitleSpan>
                <StructureItems>
                    {Object.keys(ObjectsEnum).map((key) => {
                        const item = getStructureItem(key);

                        return (
                            <StructureItem
                                key={key}
                                onClick={() => navigate(`/settings/structure/${key.toLowerCase()}`)}
                            >
                                <img src={item.icon} alt={item.name} />
                                <MediumText>{item.name}</MediumText>
                            </StructureItem>
                        );
                    })}
                </StructureItems>
            </StructureSection>
        </FixedBodyDiv>
    )
}
export const StructureItem = styled.div`
       width: 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      background-color: ${COLORS.white};
      padding: 12px 20px;
    border-top: 1px solid ${COLORS["light-bg-color"]};
    border-bottom: 1px solid ${COLORS["light-bg-color"]};

    img {
      width: 24px;
      height: 24px;
      &[data-type="plus-icon"] {
        width: 20px;
        height: 20px;
      }
    }

    p {
      color: ${COLORS.secondary1};
    }

    &:first-child {
      border-top: none;
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
    }
  
     &:last-child {
      border-bottom: none;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
    }
  
    &:hover {
      background-color: ${COLORS["light-blue"]};
      transition: background-color 0.6s ease;
      cursor: pointer;
    }

    &.structure-item--disabled {
  opacity: 0.5;
  filter: grayscale(0.2);
  transition: opacity 0.2s ease;
}

&.structure-item--disabled:hover {
  opacity: 0.7;
}
`

export const StructureItems = styled.div`
  width: 100%;
  border: 1px solid ${COLORS["light-bg-color"]};
  border-radius: 8px;
  .structure-group {
    > ${StructureItem}:first-child {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
`;



export const StructureSection = styled.div`
    padding: 16px;
    border-radius: 8px;
    background-color: ${COLORS.gray};
    box-shadow: 2px 2px 2px 0 rgba(9, 21, 64, 0.25);
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;

    ${MediumText} {
        color: ${COLORS.secondary1};
    }
`